import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BaseHttpClient } from '../../services/http-client';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AppSettings } from '../../shared/app-settings';
import { ConfigService } from '../../services/config.service';

@Injectable({ providedIn: 'root' })
export class LoginService {
    public isLoggedIn = signal<boolean>(false);
    constructor(private router: Router, private http: BaseHttpClient, private configService: ConfigService) {
        this.isLoggedIn.set(localStorage.getItem(AppSettings.StorageKeys.Token) ? true : false);
    }

    login(loginRequest: any) {
        return this.http.post(`${this.configService.get('apiBaseUrl')}/Authentication/Login`,
            loginRequest).pipe(map((response: any) => {
                return response;
            }));
    }
    
    getDomainDetails(domainName) {
        return this.http.get(`${this.configService.get('apiBaseUrl')}/Authentication/GetDomainDetails?domainName=${domainName}`).pipe(map((response: any) => {
            return response;
        }));
    }

    o365Login(o365LoginRequest) {
        return this.http.post(`${this.configService.get('apiBaseUrl')}/Authentication/O365Login`, o365LoginRequest).pipe(map((response: any) => {
            return response;
        }));
    }

    /**
     * Sets JWT token from tenant switch exchange.
     * @param token - JWT token returned by exchange-token
     */
    setTokenFromSwitch(token: string): void {
        if (!token) {
            return;
        }

        // Update token in localStorage
        localStorage.setItem(AppSettings.StorageKeys.Token, token);
        
        // Update logged in state
        this.isLoggedIn.set(true);
        
        // Parse and store user data from token
        try {
            const tokenPayload = this.parseJwtToken(token);
            if (tokenPayload) {
                const user = {
                    userId: tokenPayload.userId,
                    userFullname: tokenPayload.userFullName,
                    userEmail: tokenPayload.userEmail,
                    userLanguage: tokenPayload.userSysLanguage || 'no',
                    accountName: tokenPayload.clientDomain,
                    userEmployeeNo: tokenPayload.userEmplNo,
                    userLevel: tokenPayload.userLevelID,
                    userLevelIntra: tokenPayload.userLevelIntra,
                    userAdmin: tokenPayload.userAdmin,
                    isExternalUser: tokenPayload.isExternalUser === '1' || tokenPayload.isExternalUser === 1 || tokenPayload.isExternalUser === true || tokenPayload.isExternalUser === 'true'
                };
                localStorage.setItem(AppSettings.StorageKeys.User, JSON.stringify(user));
            }
        } catch (error) {
            console.error('Failed to parse token payload:', error);
        }
    }

    /**
     * Parses JWT token to extract payload
     * @param token - JWT token string
     * @returns Token payload object or null
     */
    private parseJwtToken(token: string): any {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error('Failed to parse JWT token:', error);
            return null;
        }
    }
}
